﻿import { formatIntThousandSeparated } from '../site.js';

(function ($) {
    
    $(function () {
        var $priceBlocks = document.querySelectorAll(".price-package");
        // Only run in __PricePackageBlock.cshtml
        if ($priceBlocks.length < 1)
            return;

        var $numberOfEmployeesInputContainer = document.querySelector(".textInputBlock");
        if ($numberOfEmployeesInputContainer == null)
            return;


        // Dom hack to have flex-styles added correctly. Sorry -sigve
        var $priceBlocksContainer = $priceBlocks[0].parentElement;
        $priceBlocksContainer.classList.add("flex-container");
        for (var i = 1; i < $priceBlocks.length; i++) {
            var $oldParent = $priceBlocks[i].parentElement;
            $priceBlocksContainer.appendChild($priceBlocks[i]);
            $oldParent.parentElement.removeChild($oldParent);
        }


        var $numberOfEmployeesInputArea = $numberOfEmployeesInputContainer.querySelector("input[type=text]");
        var $numberOfEmployeesButton = $numberOfEmployeesInputContainer.querySelector("button");

        $numberOfEmployeesButton.addEventListener("click", function () {
            var numberOfEmployees = parseInt($numberOfEmployeesInputArea.value);

            // Enable buttons
            var orderButtons = document.querySelectorAll("button:disabled");
            for (var i = 0; i < orderButtons.length; i++) {
                orderButtons[i].removeAttribute("disabled");
            }

            for (var i = 0; i < $priceBlocks.length; i++) {
                var priceBlock = $priceBlocks[i];
                var $priceDisplayContainer = priceBlock.querySelector(".price");
                if ($priceDisplayContainer == null) {
                    $priceBlocks[0].scrollIntoView();
                    return;
                }

                var $hiddenInputEmployeesCount = priceBlock.querySelector("input[name=numberOfEmployees]");
                var $hiddenInputPrice = priceBlock.querySelector("input[name=price]");
                var price20participants = parseInt(priceBlock.dataset.price20participants);
                var price100participants = parseInt(priceBlock.dataset.price100participants);
                var price500participants = parseInt(priceBlock.dataset.price500participants);
                var priceover500participants = parseInt(priceBlock.dataset.priceover500participants);
                var pricePrUserUnder1000Employees = parseInt(priceBlock.dataset.pricepruser);
                var pricePrUserOver1000Employees = parseInt(priceBlock.dataset.pricepruserover1000employees);
                var minimumPrUserPrice = parseInt(priceBlock.dataset.minimumpruserprice);

                var calculatedPrice = price20participants;

                if (numberOfEmployees > 20 && numberOfEmployees <= 100) {
                    calculatedPrice = price100participants;
                }

                else if (numberOfEmployees > 100 && numberOfEmployees <= 500) {
                    calculatedPrice = price500participants;
                }

                else if (numberOfEmployees > 500) {
                    calculatedPrice = priceover500participants;
                }

                // Calculate userprice
                var combinedUsersPrice = 0;
                var numberOfEmployeesOver1000 = numberOfEmployees - 1000;
                if (numberOfEmployeesOver1000 > 0)
                    combinedUsersPrice = (numberOfEmployeesOver1000 * pricePrUserOver1000Employees) + (pricePrUserUnder1000Employees * 1000);
                else
                    combinedUsersPrice = numberOfEmployees * pricePrUserUnder1000Employees;

                if (combinedUsersPrice < minimumPrUserPrice) {
                    combinedUsersPrice = minimumPrUserPrice;
                }

                if (!isNaN(combinedUsersPrice)) {
                    calculatedPrice += combinedUsersPrice;
                }

                $priceDisplayContainer.innerText = formatIntThousandSeparated(calculatedPrice);
                $hiddenInputPrice.value = calculatedPrice;
                $hiddenInputEmployeesCount.value = numberOfEmployees;
            }

            $priceBlocks[0].scrollIntoView();
        });


    });
})(jQuery);